import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { handleDepoimentos } from "../../../api/depoimento";
import { testimonial_1 } from "../../../data";
import React, { useEffect, useState } from 'react';

const TestimonialTwo = () => {

  const [depoimentos, setDepoimentos] = useState([]);
 
  useEffect(function() {
    handleDepoimentos().then(function(result) {
      setDepoimentos(result);
    });
  }, []);

  return (
    <>
      <section className="testimonial__area testimonial__overlay pt-175 pb-170">
        <div className="container">
          <div className="col-xxl-12">
            <div className="testimonial__slider swiper-container">
              <div className="testimonial__slider-inner swiper-wrapper">

                <Swiper modules={[Navigation]}
                  spaceBetween={1}
                  slidesPerView={4}
                  loop={true}
                  navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev', }}
                  autoplay={{ delay: 6000 }}
                >
                  {depoimentos.map(item => {
                    return (
                      <SwiperSlide key={item.id}>
                        <div className="testimonial__item text-center swiper-slide">
                          <div className="testimonial__thumb">
                            <img src={"https://v1.profaprizattera.com.br/uploads/depoimento/"+item.file} alt="" style={{maxWidth: "220px", height: "auto"}} />
                          </div>
                          {/* <div className="testimonial__content">
                            <p>{item.content}</p>

                            <div className="testimonial__info">
                              <h4>{item.name}</h4>
                              <span>{item.title}</span>
                            </div>
                          </div> */}
                        </div>
                      </SwiperSlide>
                    )
                  })
                  }
                </Swiper>

              <div className="swiper-button-next swiper-nav"><i className="far fa-arrow-right"></i></div>
              <div className="swiper-button-prev swiper-nav"><i className="far fa-arrow-left"></i></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TestimonialTwo;